module.exports = __webpack_public_path__ + "static/media/gb-flag.2f78b4bd.png";